import jQuery from 'jquery';
import 'jquery-validate';
import retargetingTracking from '@shared/tracking-retargeting';
import { qtsp } from '@shared/tracking-qtsbinds';
import { getCookie, setCookie, setReferralCookie } from '@shared/cookie';
import { cookieBase } from 'server-data/flconfigs';
import { coupon } from 'server-data/homepage';
import heroSliderFactory from '@shared/slider';

const newShowcaseItems = Array.from(
  document.querySelectorAll('.ArticleSnapshot .PageHome-showcase-cardImage'),
);

setReferralCookie();
if (typeof coupon === 'string' && coupon !== '') {
  setCookie(`${cookieBase}_COUPON`, coupon, 31);
}

jQuery('[data-action="hire-section"]').click(() => {
  retargetingTracking.paTrack2('track', 'FrontHire');
  retargetingTracking.fbTrack2('track', 'FrontHire');
});

jQuery('[data-action="work-section"]').click(() => {
  retargetingTracking.paTrack2('track', 'FrontWork');
  retargetingTracking.fbTrack2('track', 'FrontWork');
});

if (window.performance && window.performance.mark) {
  window.performance.mark('homepage_js_ready');
}

// Include csrf_token into all AJAX requests.
jQuery.ajaxPrefilter((options, originalOptions, jqXHR) => {
  const xsrfToken = getCookie('XSRF-TOKEN');
  // set the header for ALL ajax
  jqXHR.setRequestHeader('X-XSRF-TOKEN', xsrfToken);
});

const slidesList = document.querySelectorAll('[data-hero="slide"]');
const slideControlsList = Array.from(
  document.querySelectorAll('[data-hero="slide-control"]'),
);

// Initialize the hero slider and the controls click handler
// TODO: This part badly needs a refactor. The way the sliders and the
// clickable controls work together is just pure hackiness and can be
// abstracted away in a module.
const heroSlider = heroSliderFactory(slidesList, {
  onSlideSwitched: previousPaneIndex => {
    slideControlsList[previousPaneIndex].classList.remove('is-selected');
    slideControlsList[heroSlider.getActiveSlideIndex()].classList.add(
      'is-selected',
    );
  },
});
slideControlsList.forEach(control => {
  control.addEventListener('click', event => {
    const clickedControlIndex = slideControlsList.findIndex(
      controlEl => controlEl === event.target,
    );
    // Switch slider
    heroSlider.switchToSlide(clickedControlIndex);
    // Restart slideshow timer
    heroSlider.stopSlideshow();
    heroSlider.startSlideshow(5000);
  });
});
heroSlider.startSlideshow(5000);

newShowcaseItems.forEach(showcaseItem => {
  showcaseItem.addEventListener('click', () => {
    qtsp.push({
      eventName: 'user_action',
      section: showcaseItem.getAttribute('data-qtsb-section'),
      subsection: showcaseItem.getAttribute('data-qtsb-subsection'),
      label: showcaseItem.getAttribute('data-qtsb-label'),
    });
  });
});
